import React, { FunctionComponent, useCallback } from "react";
import { Link, NavLink } from "react-router-dom";
import { HeaderWrapper } from "./styles";

declare global {
  interface Window {
    bootstrap?: {
      Offcanvas: {
        getInstance: (element: HTMLElement) => { hide: () => void } | null;
      };
    };
  }
}

/** Bootstrap bundle is often loaded as a Webpack module, so `window.bootstrap` may be missing. */
function hideSiteOffcanvas(panel: HTMLElement) {
  const dismissBtn = panel.querySelector<HTMLButtonElement>(
    "button[data-bs-dismiss='offcanvas']",
  );
  if (dismissBtn) {
    dismissBtn.click();
    return;
  }
  const Offcanvas = window.bootstrap?.Offcanvas;
  if (Offcanvas) {
    Offcanvas.getInstance(panel)?.hide();
  }
}

const navItems: { to: string; label: string; exact?: boolean }[] = [
  { to: "/", label: "Home", exact: true },
  { to: "/Projects", label: "Projects" },
  { to: "/AboutUs", label: "About" },
  { to: "/Contact", label: "Contact" },
];

const MOBILE_NAV_ID = "siteNavOffcanvas";

const Header: FunctionComponent = () => {
  const logoImg = require("../../../assets/images/bv-logo.png");

  const closeMobileNav = useCallback(() => {
    const el = document.getElementById(MOBILE_NAV_ID);
    if (!el) return;
    hideSiteOffcanvas(el);
  }, []);

  const handleDownloadCV = () => {
    const fileUrl = require("../../../assets/profile-bharathreddy.pdf");
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "BharathVadde_CV.pdf";
    link.click();
  };

  return (
    <HeaderWrapper>
      <div className="site-header__shell">
        <div className="container site-header__bar">
          <Link to="/" className="site-header__brand">
            <img src={logoImg} alt="Bharath Vadde" />
          </Link>

          <nav
            className="site-header__nav d-none d-lg-flex"
            aria-label="Primary"
          >
            {navItems.map(({ to, label, exact }) => (
              <NavLink
                key={to}
                to={to}
                exact={exact}
                className="site-header__link"
                activeClassName="is-active"
                isActive={
                  to === "/"
                    ? (_, loc) =>
                        loc.pathname === "/" || loc.pathname === "/home"
                    : undefined
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="site-header__cta d-none d-lg-flex">
            <button
              type="button"
              className="site-header__btn"
              onClick={handleDownloadCV}
            >
              Download CV
            </button>
          </div>

          <button
            type="button"
            className="site-header__toggle d-lg-none"
            data-bs-toggle="offcanvas"
            data-bs-target={`#${MOBILE_NAV_ID}`}
            aria-controls={MOBILE_NAV_ID}
            aria-expanded="false"
            aria-label="Open menu"
          >
            <span className="site-header__toggle-bar" />
            <span className="site-header__toggle-bar" />
            <span className="site-header__toggle-bar" />
          </button>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end site-header__drawer"
        tabIndex={-1}
        id={MOBILE_NAV_ID}
        aria-labelledby="siteNavOffcanvasLabel"
      >
        <div className="offcanvas-header">
          <span className="site-header__drawer-title" id="siteNavOffcanvasLabel">
            Navigate
          </span>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close menu"
          />
        </div>
        <div className="offcanvas-body">
          <nav className="site-header__drawer-nav" aria-label="Mobile primary">
            {navItems.map(({ to, label, exact }) => (
              <NavLink
                key={to}
                to={to}
                exact={exact}
                className="site-header__drawer-link"
                activeClassName="is-active"
                isActive={
                  to === "/"
                    ? (_, loc) =>
                        loc.pathname === "/" || loc.pathname === "/home"
                    : undefined
                }
                onClick={closeMobileNav}
              >
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="site-header__drawer-cta">
            <button
              type="button"
              className="site-header__btn"
              onClick={() => {
                closeMobileNav();
                handleDownloadCV();
              }}
            >
              Download CV
            </button>
          </div>
        </div>
      </div>
    </HeaderWrapper>
  );
};

export default Header;
